export
const name: string = "Xray";

export
const preproc: string = ``;

export
const declaration: string = ``;

export
const varyings: string = ``;

export
const implementation: string = ``;
